import { useEffect, useState } from "react";
import DataTable, { Column } from "../../../components/DataTable";
import ToggleSwitch from "../../../components/ToggleSwitch";
import { useEditMode } from "../../../context/EditModeContext";
import useConfirmToast from "../../../util/hooks/useConfirmToast";
import { AcademicCycle } from "../../../types/schoolBranchType";
import { toast } from "sonner";
import StaffApis from "../../../api/staffApis";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { useSelector } from "react-redux";

interface ClassAccessProps {
  staffId?: number;
  academicCycles: AcademicCycle[];
  onRefresh?: () => Promise<void>;
}

export default function ClassAccess({
  staffId,
  academicCycles,
  onRefresh,
}: ClassAccessProps) {
  const [searchFilters, setSearchFilters] = useState({});
  const { isEditing } = useEditMode();
  const { confirm, modal } = useConfirmToast();
  const location = useLocation();
  const tab = new URLSearchParams(location.search).get("tab");

  // const dispatch = useDispatch<AppDispatch>();
  // const staff = useSelector((state: RootState) => state.access.academicCycles);

  const shouldHideLabel =
    location.pathname === "/view-profile" && tab === "Class Access";

  const handleToggle = async (
    academicCycle: AcademicCycle,
    nextValue: boolean,
  ) => {
    if (!staffId) {
      toast.error("Invalid staff ID");
      return;
    }

    try {
      const response = await StaffApis.toggleAcademicCycle(
        staffId,
        academicCycle.academicCycleId,
      );

      if (response?.status === 1) {
        toast.success(response.data);
        if (onRefresh) await onRefresh();
      } else {
        throw new Error();
      }
    } catch {
      toast.error("Failed to update academic cycle");
    }
  };

  const columns: Column<AcademicCycle>[] = [
    {
      label: "SL NO.",
      accessor: "academicCycleId",
      render: (_, index) => <p>{index + 1}</p>,
    },
    // {
    //   label: "Classes List",
    //   accessor: "classesList",
    //   searchable: true,
    //   render: (item) => (
    //     <div className="font-bold text-sm text-neutral-400">
    //       {item.classesList}
    //       A1 hardcoded for now
    //     </div>
    //   ),
    // },
    {
      label: "Academic Cycle",
      accessor: "academicCycle",
      // searchable: true,
      render: (item) => (
        <div className="font-medium text-xs px-2 p-1 rounded text-primary-600 w-fit bg-primary-50">
          {item.academicCycleName}
        </div>
      ),
    },
    {
      label: "Access",
      accessor: "access",
      searchable: false,
      render: (item) => (
        <ToggleSwitch
          defaultChecked={item.active}
          disabled={!isEditing}
          confirmToggle={(next) =>
            confirm(
              next
                ? "Are you sure you want to enable this access?"
                : "Are you sure you want to disable this access?",
              {
                confirmText: "yes",
              },
            )
          }
          onToggle={(next) => handleToggle(item, next)}
        />
      ),
    },
  ];

  const handleSearchChange = (accessor, value) => {
    setSearchFilters((prev) => ({ ...prev, [accessor]: value }));
  };

  const handleSearchSubmit = (filters) => {
    console.log("Search filters:", filters);
    setSearchFilters(filters);
  };

  return (
    <div className="px-4 md:px-9 py-7 flex flex-col gap-8">
      {!shouldHideLabel && (
        <label className="text-xs font-medium text-error-500">
          *Admin, Principals, Directors, Coordinators & Center Heads will have
          access to all classrooms and this access cannot be disabled
        </label>
      )}
      <DataTable
        columns={columns}
        data={academicCycles}
        searchFilters={searchFilters}
        onSearchChange={handleSearchChange}
        onSearchSubmit={handleSearchSubmit}
      />
      {modal}
    </div>
  );
}
